import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Palette,
  Search,
  Settings,
  Power,
  ChevronRight,
  Bell,
  FileBarChart,
} from "lucide-react";

import { Biohazard, LayoutDashboard } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../feature/user/userSlice";
import {
  hidesidebar,
  showsidebar,
} from "../../feature/sidebartoggle/sidebarToggleSlice";
import { FaRegUserCircle } from "react-icons/fa";
import {
  People,
  CardList,
  GeoAlt,
  PCircle,
  LayerForward,
  Virus,
  Database,
  ClipboardData,
} from "react-bootstrap-icons";
import axios from "axios";
import { API_SRC } from "../../common/Constants";
import { API_Link, ValidateHeader } from "../../common/Constants";

/* *******************************************************************
 ***********************   Maltipla Colors teheme Start  ********************
 **********************************************************************/

import SampleCollection from "./../icons/Sample_collection";
import { Stool2, Stool } from "./../icons/Stool";
import Environment from "./../icons/Environment";
import Serum from "./../icons/Serum";
// import Search from './../icons/Search';
import Logo from "../icons/logo";
import Virus_isolation from "../icons/Virus_isolation";
import Processing from "../icons/Processing";
import Incolution from "../icons/Incolution";
/* *******************************************************************
 ***********************   Maltipla Colors teheme Start  ********************
 **********************************************************************/

const Sidebar = () => {
  const location = useLocation();
  const sidebarToggle = useSelector((state) => state.toggler.value);
  const user = useSelector((state) => state.user.user);
  const token = user?.token;

  const menues = user?.menu;
  const sideMenues = menues?.filter((item) => item.module === "sideBar");

  const parentMenus = menues?.filter(
    (item) => item.module === "sideBar" && item.parent_id === null,
  );
  const [notificationCount, setNotificationCount] = useState(0);
  // Filter submenus that do not have a corresponding parent menu
  const nestedSubMenus = menues
    ?.filter((item) => item.module === "sideBar" && item.parent_id !== null)
    ?.filter(
      (item) => !parentMenus.some((parent) => parent.id === item.parent_id),
    );

  // Function TO Reshape Menues In Desird Format
  const reshapeMenu = parentMenus?.map((parent) => {
    const childMenus = menues?.filter((item) => parent.id === item.parent_id);
    return {
      ...parent,
      submenus: childMenus,
    };
  });
  const sideMenu = reshapeMenu?.map((menu) => ({ isOpen: false, ...menu }));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleShowSidebar = () => {
    dispatch(showsidebar());
  };
  const handleHideSidebar = () => {
    dispatch(hidesidebar());
  };
  const [menus, setMenus] = useState(sideMenu);
  const [activeLink, setactiveLink] = useState("");
  const handleOpenMenu = (id) => {
    setMenus((prevMenus) => {
      return prevMenus.map((menu) => {
        if (menu.id === id) {
          return { ...menu, isOpen: !menu.isOpen };
        }
        // return menu;
        return { ...menu, isOpen: false };
      });
    });
  };
  // const handleOpenMenu = (id) => {
  //   const updatedMenus = menus.map((menu) => {
  //     if (menu.id === id) {
  //       return { ...menu, isOpen: !menu.isOpen };
  //     }
  //     return { ...menu, isOpen: false };
  //   });
  //   setMenus(updatedMenus);
  // };
  const handleAciveSubmenu = (id) => {};

  useEffect(() => {
    const url = location.pathname.split("/")[1];
    const selectedSubmenu = menus
      ?.flatMap((menu) => menu?.submenus)
      ?.find((submenu) => location.pathname.includes(submenu?.link));
    setactiveLink(selectedSubmenu?.link);
  }, [location.pathname]);
  const [count, setCount] = useState(1);
  useEffect(() => {
    const selectedMenu = menus?.find((menu) =>
      menu?.submenus?.find((sm) => location.pathname.includes(sm.link)),
    );
    const updatedMenus = menus?.map((menu) => {
      if (menu?.id === selectedMenu?.id) {
        return { ...menu, isOpen: true };
      }
      return { ...menu, isOpen: false };
    });
    setMenus(updatedMenus);
  }, [location.pathname]);

  const handleLogout = () => {
    dispatch(logout(user.token))
      .then(() => {
        navigate("/");
      })
      .catch((error) => {});
  };

  /* *******************************************************************
   ***********************   Maltipla Colors teheme Start  ********************
   **********************************************************************/

  const [isColorDivVisible, setColorDivVisible] = useState(false);
  const toggleDiv = () => {
    setColorDivVisible(!isColorDivVisible);
  };

  useEffect(() => {
    localStorage.setItem("ids_color", "primary-color");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage

      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  }, []);
  const colorThemePrimary = () => {
    localStorage.setItem("ids_color", "primary-color");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      if (colorValue === "blue") {
        newClasses.push("blue");
      } else {
        newClasses.push("primary-color");
      }

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };

  const colorBlue = () => {
    localStorage.setItem("ids_color", "blue");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };

  const colorGreen = () => {
    localStorage.setItem("ids_color", "green");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };
  const colorGray = () => {
    localStorage.setItem("ids_color", "gray");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };
  const colorPink = () => {
    localStorage.setItem("ids_color", "pink");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };
  const colorYellow = () => {
    localStorage.setItem("ids_color", "yellow");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };
  const colorOrange = () => {
    localStorage.setItem("ids_color", "orange");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };
  const colorDark = () => {
    localStorage.setItem("ids_color", "dark");
    const element = document.getElementById("main-body");
    if (element) {
      const newClasses = ["app", "main-wrapper"];

      // Retrieve the color value from local storage
      const colorValue = localStorage.getItem("ids_color");
      newClasses.push(colorValue);

      // Remove all existing classes
      element.classList.remove(...element.classList);

      // Add the new classes
      newClasses.forEach((classValue) => {
        element.classList.add(classValue);
      });
    }
  };

  // Use ref to prevent multiple intervals
  const intervalRef = useRef(null);
  // Check if user has notification menu access
const hasNotificationAccess = menues?.some(menu => menu.title === "Notifications");
  // Function to fetch notification count from API
  const fetchNotificationCount = async () => {
    // Only fetch if token exists
    if (!token || !hasNotificationAccess) return;

    const config = {
      method: "get",
      url: `${API_Link}finalDelayedResults`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "plims-auth": ValidateHeader,
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axios(config);

      if (response.data.status === 1) {
        const count = response?.data.summary?.total_delayed_samples || 0;
        setNotificationCount(count);
      } else {
        setNotificationCount(0);
      }
    } catch (error) {
      console.error("Error fetching notification count:", error);
      if (
        error.response &&
        error.response.data.message === "Unauthenticated."
      ) {
        navigate("/");
        sessionStorage.clear();
        localStorage.clear();
      }
    }
  };

  // Initial fetch on component mount
  useEffect(() => {
    if (token && hasNotificationAccess) {
      fetchNotificationCount();
    }
  }, [token, hasNotificationAccess]);

  // Set up interval to fetch notification count every 5 seconds
  useEffect(() => {
    if (!token || !hasNotificationAccess) return;

    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // Start new interval with 5 seconds
    intervalRef.current = setInterval(() => {
      fetchNotificationCount();
    }, 100000); // 5 seconds = 5000 milliseconds

    // Cleanup interval on component unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [token, hasNotificationAccess]); // Re-run if token or notification access changes

  /* *******************************************************************
   ***********************   Maltipla Colors teheme End  ********************
   **********************************************************************/
  return (
    <div className="d-flex flex-column justify-content-between sidebar-innerWrapper">
      <div>
        <div className="sidebar mb-3">
          <span className="logo">
            <Logo />
          </span>
          <Link>VLIMS</Link>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {sideMenues?.map((menu, index) => (
              <li
                key={index}
                className="nav-item nav-item-active sub-menu-open"
              >
                {menu.parent_id === null ? (
                  <>
                    <Link
                      className={
                        menu?.isOpen
                          ? "nav-link nav-link-active nav-link-center "
                          : `nav-link  nav-link-center `
                      }
                      to={menu?.link}
                    >
                      <div className="menu-item-wrapper">
                        <span className="menue-title ms-2 menue-icon ">
                          {menu?.title === "Access Management" ? (
                            <span>
                              <People />
                            </span>
                          ) : menu?.title === "Lookups Management" ? (
                            <CardList />
                          ) : menu?.title === "Location Management" ? (
                            <GeoAlt />
                          ) : menu?.title === "Inventory Management" ? (
                            <ClipboardData />
                          ) : menu?.title === "Sample Registration" ? (
                            <span>
                              <SampleCollection />
                            </span>
                          ) : menu?.title === "Virus Isolation" ? (
                            <span>
                              <Stool2 />
                            </span>
                          ) : menu?.title === "AFP" ? (
                            <span>
                              <Processing />
                            </span>
                          ) : menu?.title === "Environment" ? (
                            <span>
                              <Incolution />
                            </span>
                          ) : menu?.title === "Analytics" ? (
                            <span>
                              <LayoutDashboard />
                            </span>
                          ) : menu?.title === "PCR" ? (
                            <span>
                              <PCircle />
                            </span>
                          ) : menu?.title === "Sequencing" ? (
                            <span>
                              <LayerForward />
                            </span>
                          ) : menu?.title === "Bio Medical" ? (
                            <span>
                              <Biohazard />
                            </span>
                          ) : menu?.title === "Cell Culture" ? (
                            <span>
                              <Virus />
                            </span>
                          ) : menu?.title === "Inventory" ? (
                            <span>
                              <Database />
                            </span>
                          ) : menu?.title === "Data Unit Reports" ? (
                            <span>
                              <FileBarChart />
                            </span>
                          ): (
                            ""
                          )}
                        </span>
                        <span className="menue-title-hover">{menu.title}</span>
                      </div>
                    </Link>
                    {/* <div className="wrapper-dropdown">
                      <div className="drop-down nested-sub-menus-hover ">
                        {sideMenues?.map(
                          (item) =>
                            menu.id === item.parent_id && (
                              <li
                                key={item.id}
                                className={
                                  location.pathname === `/${item?.link}`
                                    ? "submenue-list-item submenue-link-active"
                                    : "submenue-list-item"
                                }
                                onClick={() => handleAciveSubmenu(item?.id)}
                              >
                                <Link
                                  className="submenue-link  "
                                  to={item?.link}
                                >
                                  <span className="">{item?.title}</span>
                                  <span>
                                    {(item.title === "Search" && (
                                      <Search size={20} />
                                    )) ||
                                      (item.title === "Stool" && <Stool />) ||
                                      (item.title === "Environment" && (
                                        <Environment />
                                      )) ||
                                      (item.title === "Serum" && <Serum />) ||
                                      (item?.title === "Cell Line Record" && (
                                        <ChevronRight />
                                      )) ||
                                      (item?.title === "Cell Culture Media" && (
                                        <ChevronRight />
                                      ))}
                                  </span>
                                </Link>
                                <div
                                  className={
                                    item.title === "Cell Culture Media" &&
                                    user?.user?.role_id == 14
                                      ? "nested-sub-menus-wrapper nested-sub-menus-wrapper-media"
                                      : "nested-sub-menus-wrapper"
                                  }
                                  // className="nested-sub-menus-wrapper"
                                >
                                  <ul className="nested-sub-menus">
                                    {nestedSubMenus
                                      .filter(
                                        (subMenu) =>
                                          subMenu.parent_id === item.id
                                      )
                                      .map((itemSub) => (
                                        <li
                                          key={itemSub.id}
                                          className={
                                            location.pathname ===
                                            `/${itemSub?.link}`
                                              ? "submenue-list-item submenue-link-active"
                                              : "submenue-list-item"
                                          }
                                          onClick={() =>
                                            handleAciveSubmenu(itemSub?.id)
                                          }
                                        >
                                          <Link
                                            className="submenue-link"
                                            to={itemSub?.link}
                                          >
                                            <span>{itemSub?.title}</span>
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              </li>
                            )
                        )}
                        
                      </div>
                    </div> */}
                    <div className="wrapper-dropdown">
                      <div className="drop-down nested-sub-menus-hover ">
                        {sideMenues?.map(
                          (item) =>
                            menu.id === item.parent_id && (
                              <li
                                key={item.id}
                                className={
                                  location.pathname === `/${item?.link}`
                                    ? "submenue-list-item submenue-link-active"
                                    : "submenue-list-item"
                                }
                                onClick={() => handleAciveSubmenu(item?.id)}
                              >
                                <Link
                                  className="submenue-link  "
                                  to={item?.link}
                                >
                                  <span className="">{item?.title}</span>
                                  <span>
                                    {(item.title === "Search" && (
                                      <Search size={20} />
                                    )) ||
                                      (item.title === "Stool" && <Stool />) ||
                                      (item.title === "Environment" && (
                                        <Environment />
                                      )) ||
                                      (item.title === "Serum" && <Serum />) ||
                                      (item?.title === "Cell Line Record" &&
                                        nestedSubMenus.some(
                                          (sub) => sub.parent_id === item.id,
                                        ) && <ChevronRight />) ||
                                      (item?.title === "Cell Culture Media" &&
                                        nestedSubMenus.some(
                                          (sub) => sub.parent_id === item.id,
                                        ) && <ChevronRight />)}
                                  </span>
                                </Link>
                                <div
                                  className={
                                    item.title === "Cell Culture Media" &&
                                    user?.user?.role_id == 14
                                      ? "nested-sub-menus-wrapper nested-sub-menus-wrapper-media"
                                      : "nested-sub-menus-wrapper"
                                  }
                                >
                                  <ul className="nested-sub-menus">
                                    {nestedSubMenus
                                      .filter(
                                        (subMenu) =>
                                          subMenu.parent_id === item.id,
                                      )
                                      .map((itemSub) => (
                                        <li
                                          key={itemSub.id}
                                          className={
                                            location.pathname ===
                                            `/${itemSub?.link}`
                                              ? "submenue-list-item submenue-link-active"
                                              : "submenue-list-item"
                                          }
                                          onClick={() =>
                                            handleAciveSubmenu(itemSub?.id)
                                          }
                                        >
                                          <Link
                                            className="submenue-link"
                                            to={itemSub?.link}
                                          >
                                            <span>{itemSub?.title}</span>
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              </li>
                            ),
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="bottom-links">
        <ul>
          {/* <li>
            
            <Link to="/tatComplianceReport">
              
              <i className="" title="Notifications ">
                {" "}
                <Bell color="white" size={20} />
              </i>
            </Link>
          </li> */}
          {menues?.map(
            (menu) =>
              menu.title === "Notifications" && (
                <li>
                  <Link to="/tatComplianceReport" className="position-relative">
                    <Bell color="white" size={23} />
                    {notificationCount > 0 && (
                      <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                        style={{
                          fontSize: "10px",
                          padding: "4px 4px",
                          marginTop: "-5px",
                          marginLeft: "0px",
                        }}
                      >
                        {notificationCount}
                        {/* {notificationCount > 99 ? "99+" : notificationCount} */}
                      </span>
                    )}
                  </Link>
                </li>
              ),
          )}

          <li>
            {/* <Link to='/tutorial'> */}
            <Link to="/searching">
              {/* <i className='bi bi-patch-question text-light' title='Help'>     <Search /></i> */}
              <i className="" title="Search">
                {" "}
                <Search color="white" size={20} />
              </i>
            </Link>
          </li>
          <li onClick={toggleDiv} title="Theme">
            <i className=" text-light">
              <Palette color="white" size={20} />{" "}
            </i>

            {isColorDivVisible && (
              <div className="color-div">
                <div className="d-flex justify-content-between">
                  <div
                    className="blue-theme circle-div circle-bg-primary-color"
                    onClick={colorThemePrimary}
                  ></div>
                  <div
                    className="blue-theme circle-div circle-bg-blue-color"
                    onClick={colorBlue}
                  ></div>
                  <div
                    className="blue-theme circle-div circle-bg-green-color"
                    onClick={colorGreen}
                  ></div>
                  <div
                    className="blue-theme circle-div circle-bg-yellow-color"
                    onClick={colorYellow}
                  ></div>
                </div>
                <div className="d-flex justify-content-between">
                  <div
                    className="blue-theme circle-div circle-bg-pink-color"
                    onClick={colorPink}
                  ></div>
                  <div
                    className="blue-theme circle-div circle-bg-orange-color"
                    onClick={colorOrange}
                  ></div>
                  <div
                    className="blue-theme circle-div circle-bg-gray-color"
                    onClick={colorGray}
                  ></div>
                  <div
                    className="blue-theme circle-div circle-bg-dark-color"
                    onClick={colorDark}
                  ></div>
                </div>
              </div>
            )}
          </li>
          {user.role.role === "admin" && (
            <li>
              <Link to="/admin/SettingPage">
                <i className=" text-light" title="Setting">
                  <Settings color="white" size={20} />{" "}
                </i>
              </Link>
            </li>
          )}
          <li className="drop-down-wrapper-bottom-custom ">
            <Link to="/profile">
              <i className="text-light" title="Profile">
                {" "}
                <FaRegUserCircle color="white" size={20} />
              </i>

              <div className="dropdown-content-custom text-start   ">
                <div className="header-dropdown">
                  <h6 className="mb-0">{user?.user?.name}</h6>
                  <p className="small fw-light mb-0">{user?.user?.email}</p>
                  <div className="pills rounded  px-3 py-1 mt-1 d-inline-block text-capitalize mb-0 role-pill btn-reciveing-theme">
                    {user?.role?.role}
                  </div>
                </div>
              </div>
            </Link>
          </li>

          <li>
            <button className="border-0 bg-remove" onClick={handleLogout}>
              <i className="text-light" title="logout">
                {" "}
                <Power color="white" size={20} />
              </i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
